import Covid from "./components/covid";
import "./components/covid.css"

const App = () => {
  return ( 
    <div>
        <Covid/>
    </div>

   );
}
 
export default App;
